import React from 'react';
import { Box, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { baseColors } from '../../../Themes/colors';
var TEAL = baseColors.successPreset[30];
var RAIL_COLOR = baseColors.greyPreset[20];
var NavWrapper = styled(Box)(function (_a) {
    var _b;
    var iconOnly = _a.iconOnly, theme = _a.theme;
    return (_b = {
            minWidth: iconOnly ? 56 : 207,
            width: iconOnly ? 56 : 207,
            backgroundColor: baseColors.fullWhite,
            borderRadius: 8,
            paddingTop: 6,
            paddingBottom: 6,
            alignSelf: 'flex-start',
            position: 'sticky',
            top: 0,
            flexShrink: 0,
            overflow: 'hidden',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: 3,
                backgroundColor: RAIL_COLOR,
                borderRadius: '12px 0 0 12px',
                zIndex: 0,
            }
        },
        _b[theme.breakpoints.down('md')] = {
            width: '100%',
            minWidth: '100%',
            position: 'static',
            top: 'auto',
        },
        _b);
});
var NavItemRow = styled(Box)(function (_a) {
    var active = _a.active, iconOnly = _a.iconOnly;
    return ({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: iconOnly ? 'center' : 'flex-start',
        gap: iconOnly ? 0 : 4,
        padding: iconOnly ? '14px 8px' : '12px 16px',
        cursor: 'pointer',
        transition: 'background-color 0.15s',
        zIndex: 1,
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: 3,
            backgroundColor: active ? TEAL : 'transparent',
            transition: 'background-color 0.15s',
            zIndex: 2,
        },
        '&:hover': {
            '& .navIcon': {
                color: active ? TEAL : baseColors.darkPreset[10],
            },
            '& .navLabel': {
                color: active ? TEAL : baseColors.darkPreset[10],
            },
        },
        '& .navIcon': {
            fontSize: 24,
            color: active ? TEAL : baseColors.darkPreset[10],
            flexShrink: 0,
            fontWeight: 500,
        },
        '& .navLabel': {
            fontSize: 16,
            color: active ? TEAL : baseColors.darkPreset[10],
            lineHeight: 1.4,
        },
    });
});
var ChildItemRow = styled(Box)(function (_a) {
    var active = _a.active;
    return ({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        padding: '0px 16px 8px 48px',
        cursor: 'pointer',
        transition: 'background-color 0.15s',
        zIndex: 1,
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: 3,
            backgroundColor: active ? TEAL : 'transparent',
            transition: 'background-color 0.15s',
            zIndex: 2,
        },
        '&:hover': {
            color: active ? TEAL : baseColors.darkPreset[10],
        },
        '& .childLabel': {
            fontSize: 16,
            color: active ? TEAL : baseColors.darkPreset[10],
            lineHeight: 1.4,
        },
    });
});
var TabSideNav = function (_a) {
    var items = _a.items, activeId = _a.activeId, onSelect = _a.onSelect, _b = _a.iconOnly, iconOnly = _b === void 0 ? false : _b;
    var handleItemClick = function (item) {
        if (item.children && item.children.length > 0) {
            onSelect(item.children[0].id);
        }
        else {
            onSelect(item.id);
        }
    };
    return (React.createElement(NavWrapper, { iconOnly: iconOnly }, items.map(function (item) {
        var hasChildren = !!(item.children && item.children.length > 0);
        var isLeafActive = !hasChildren && activeId === item.id;
        var isParentActive = hasChildren && item.children.some(function (child) { return child.id === activeId; });
        var isActive = isLeafActive || isParentActive;
        return (React.createElement(Box, { key: item.id },
            iconOnly ? (React.createElement(Tooltip, { title: item.label, placement: "right", arrow: true },
                React.createElement(NavItemRow, { active: isActive, iconOnly: iconOnly, onClick: function () { return handleItemClick(item); }, "aria-label": item.label },
                    React.createElement("span", { className: "".concat(item.icon, " navIcon") })))) : (React.createElement(NavItemRow, { active: isActive, iconOnly: iconOnly, onClick: function () { return handleItemClick(item); } },
                React.createElement("span", { className: "".concat(item.icon, " navIcon") }),
                React.createElement(Typography, { className: "navLabel" }, item.label))),
            hasChildren && !iconOnly && (React.createElement(Box, null, item.children.map(function (child) { return (React.createElement(ChildItemRow, { key: child.id, active: activeId === child.id, onClick: function () { return onSelect(child.id); } },
                React.createElement(Typography, { className: "childLabel" }, child.label))); })))));
    })));
};
export default TabSideNav;
